import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import withRouter from 'components/components/common/withRouter';
import includes from 'lodash/includes';

class ScrollToTop extends Component {

  componentDidUpdate(prevProps) {
    var mainPageUrls = ["/", "/en", "/pl", "/no", "/ru"];
    var changeLanguageOnMainPage = includes(mainPageUrls, prevProps.location.pathname) &&
      includes(mainPageUrls, this.props.location.pathname);
    if (prevProps.locale === this.props.locale && !changeLanguageOnMainPage) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

function mapStateToProps(state) {
  return {
    locale: state.app.locale
  }
}

export default withRouter(connect(mapStateToProps)(ScrollToTop));
